import React from "react";
import { Utensils, Zap, Home, Wallet, Flame, Droplet, Trash } from "lucide-react";

export const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export const monthLabel = (ym) => { if (!ym) return "—"; const [y, m] = ym.split("-"); return `${MESI[+m - 1] || m} ${y}`; };
export const thisMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };
export const monthOptions = () => { const y = new Date().getFullYear(); const out = []; for (let yr = y - 1; yr <= y + 1; yr++) for (let i = 0; i < 12; i++) out.push(`${yr}-${String(i + 1).padStart(2, "0")}`); return out; };

export const CATS = ["vitto", "utenze", "affitto", "varie"];
export const CAT_META = {
  vitto: { label: "Vitto", icon: Utensils, color: "#b45309" },
  utenze: { label: "Utenze", icon: Zap, color: "#c2660c" },
  affitto: { label: "Affitto", icon: Home, color: "#c2410c" },
  varie: { label: "Varie", icon: Wallet, color: "#dc2626" },
};
export const catOf = (r) => (CATS.includes((r.categoria || "").toLowerCase()) ? (r.categoria || "").toLowerCase() : "varie");
export const GENERALI_ID = "generali";

// Preset rapidi di deducibilità (click)
export const DEDUC_PRESETS = [
  { label: "Auto (20%)", val: 20 },
  { label: "Telefono (80%)", val: 80 },
  { label: "Rappresentanza (75%)", val: 75 },
  { label: "Deducibile 100%", val: 100 },
];

// Deducibilità % (default 100 se non impostata)
export const dedNum = (r) => (r.deducibilita_perc == null || r.deducibilita_perc === "") ? 100 : Number(r.deducibilita_perc);

// Icone colorate per fornitori specifici (utenze)
const FORNITORE_ICONS = [
  { match: "enel-gas la villa", icon: Flame, color: "#ea580c" },
  { match: "enel-gas boschetto", icon: Flame, color: "#dc2626" },
  { match: "enel-luce", icon: Zap, color: "#eab308" },
  { match: "sii", icon: Droplet, color: "#2563eb" },
  { match: "tari", icon: Trash, color: "#7c4a2d" },
];
export const fornitoreIcon = (nome) => {
  const n = (nome || "").trim().toLowerCase();
  if (!n) return null;
  const f = FORNITORE_ICONS.find((x) => n === x.match || n.startsWith(x.match));
  if (!f) return null;
  const I = f.icon;
  return <I size={14} style={{ color: f.color }} className="shrink-0" />;
};
